import Icon from '@ant-design/icons'
import { useResponsive } from 'ahooks'
import { Link } from 'react-router-dom'
import { Markdown } from '@wair/markdown'

import useReAnswer from '@/hooks/useReAnswer'
import { chatState } from '@/store'
import { SessionStatuTypes } from '@/constants'
import InteractOperate from './InteractOperate'
import CommonElement from './CommonElement'
import ToolContent from './ToolContent'
import styles from './index.module.less'
import { getPluginInfo } from '@/components/Plugins/utils'
import { getProcessonUrl } from '@/api/chat'
import ImageLoading from './ImageLoading'
import Thinking from '@/components/Thinking'

export const getShowGenerate = (item: any) => {
  return (
    item.out_finished !== false &&
    item.answer_id &&
    !item.pluginInfo &&
    chatState.sessionStatu !== SessionStatuTypes.risk
  )
}

export const PPTPluginInfo = ({ item }: any) => {
  const pluginContent = item.plugins_content
  const pluginConfig = getPluginInfo(pluginContent.plugin_type)

  const toChatPPT = () => {
    window.open('https://chat-ppt.com/?channel=zdtc')
  }

  return (
    <div className={styles.pluginInfo}>
      <div className="flex items-center text-[14px]">
        <span>已使用插件：</span>
        <div className={styles.pluginMark}>
          <div className={styles.pluginMarkIcon}>
            <Icon component={pluginConfig.icon} className="text-xl"></Icon>
          </div>
          {pluginConfig.name}
        </div>
      </div>
      {pluginContent.images_url && (
        <>
          <span>已制作好您的PPT封面: </span>
          <img src={pluginContent.images_url} />
        </>
      )}
      <div>
        PPT支持下载：
        <Link
          className={styles.link}
          to={`/downloadPPT/${pluginContent.id}`}
          target="_blank"
        >
          点击下载到本地
        </Link>
        ；如需更多操作，可访问
        <span className={styles.link} onClick={toChatPPT}>
          插件主页
        </span>
      </div>
    </div>
  )
}

export const ProcessOnPluginInfo = ({ item }: any) => {
  const pluginContent = item.plugins_content
  const pluginConfig = getPluginInfo(pluginContent.plugin_type)

  const toProcesson = async (url: string) => {
    const newWindow = window.open('about:blank', '_blank')
    const { data } = await getProcessonUrl(url)
    newWindow?.location.replace(data.url)

    // setTimeout(() => {
    //   newWindow?.location.replace('http://www.baidu.com')
    // }, 3000)
  }

  return (
    <div className={styles.pluginInfo}>
      <div className="flex items-center text-[14px]">
        <span>已使用插件：</span>
        <div className={styles.pluginMark}>
          <div className={styles.pluginMarkIcon}>
            <Icon component={pluginConfig.icon} className="text-xl"></Icon>
          </div>
          {pluginConfig.name}
        </div>
      </div>
      {pluginContent.images_url && (
        <>
          <span>已制作好您的流程图: </span>
          <img src={pluginContent.images_url} />
        </>
      )}
      {pluginContent.edit_url && (
        <div>
          如需对图表进行编辑，请
          <span
            className={styles.link}
            onClick={() => {
              toProcesson(pluginContent.edit_url)
            }}
          >
            点击此处
          </span>
        </div>
      )}
      {pluginContent.po_url && (
        <>
          <span>剩余可用文件数不足，您可以前往</span>
          <span
            className={styles.link}
            onClick={() => {
              toProcesson(pluginContent.po_url)
            }}
          >
            ProcessOn-我的文件
          </span>
          <span>清空文件后再次尝试</span>
        </>
      )}
    </div>
  )
}

export default function AssistantContent({ item, isLast }: any) {
  const { curIndex, renderItem, handleNext, handlePre } = useReAnswer(item)
  const responsive = useResponsive()
  const showGenerate = getShowGenerate(renderItem)
  const showReasoning = renderItem.reasoning_content?.trim() !== ''

  return (
    <>
      <div className={styles.assistantContent}>
        {renderItem.loading && (
          <img
            className="w-5 h-5"
            src="https://zdtc-cdn.wair.ac.cn/public/loadding.gif"
          />
        )}
        {renderItem.events && renderItem.events.length > 0 && (
          <ToolContent content={renderItem} />
        )}
        {showReasoning && (
          <Thinking
            content={renderItem.reasoning_content}
            duration={renderItem.thinking_elapsed_secs}
            thinking={
              chatState.sessionStatu !== SessionStatuTypes.ready &&
              !renderItem.thinking_elapsed_secs &&
              !renderItem.text &&
              renderItem.stop !== 1 &&
              !item.out_finished
            }
          />
        )}
        {/* <img className='w-7 h-7' src='https://zdtc-cdn.wair.ac.cn/public/loadding.gif' /> */}
        {renderItem.action === 16 && !item.out_finished && item.stop !== 1 && (
          <ImageLoading item={renderItem} />
        )}

        {!renderItem.plugins_content?.plugin_type && (
          <CommonElement item={renderItem} />
        )}
        {!renderItem.plugins_content?.plugin_type && renderItem.text && (
          <Markdown
            renderImage={true}
            previewImage={true}
            showAnimation={
              chatState.sessionStatu === SessionStatuTypes.pending &&
              isLast &&
              !renderItem.out_finished &&
              renderItem.stop !== 1
            }
            enableCitation={true}
            content={renderItem.text}
          />
        )}
        {renderItem.plugins_content?.plugin_type === 'ppt' && (
          <PPTPluginInfo item={renderItem} />
        )}
        {renderItem.plugins_content?.plugin_type === 'processon' && (
          <ProcessOnPluginInfo item={renderItem} />
        )}
        {renderItem.stop === 1 && (
          <div className="mt-1 text-gray-400">已停止生成</div>
        )}
        {showGenerate && (
          <>
            <div className={styles.riskMark}>
              {/* <img className="w-[16px]" src={alertSquare} alt="" /> */}
              {responsive.md
                ? '以上内容为AI生成，不代表开发者立场，请勿删除或修改本标记'
                : '以上内容为AI生成'}
            </div>
            <InteractOperate
              isLast={isLast}
              renderItem={renderItem}
              curIndex={curIndex}
              handleNext={handleNext}
              handlePre={handlePre}
            />
          </>
        )}
      </div>
    </>
  )
}
